import React from 'react'
import styled from 'styled-components'
import { H6 } from 'app/common/typography'
import { SquareMinus, SquarePlus } from 'app/assets/icons'

type Props = {
    value: number,
    onPressLeft?: () => void,
    onPressRight?: () => void,
    colorLeft?: string,
    colorRight?: string,
    isBig?: boolean,
    disabled?: boolean
}

export const Stepper = ({
    colorLeft,
    colorRight,
    value,
    onPressLeft,
    onPressRight,
    isBig,
    disabled
}: Props) => {
    return (
        <RowContainerCenter>
            <Square onClick={onPressLeft} disabled={disabled}>
                <SquareMinus
                    disabled={disabled}
                    background={colorLeft}
                    color="white"
                    size={27}
                />
            </Square>
            <StyledH6 isBig={isBig}>{value}</StyledH6>
            <Square onClick={onPressRight} disabled={disabled}>
                <SquarePlus
                    disabled={disabled}
                    background={colorRight}
                    color="white"
                    size={27}
                />
            </Square>
        </RowContainerCenter>
    )
}

const RowContainerCenter = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`

const StyledH6 = styled(H6)`
    margin: 0px 5px 3px 5px;
    ${props =>
        props.isBig && 'margin: 0px 15px 3px 15px;' && 'font-size: 22px;'}
`

const Square = styled.div`
    ${props => !props.disabled && 'cursor: pointer'};
`
